import dynamic from "next/dynamic";
import FloatingIntegrationsConfig from "./floating-integrations-config";
import FloatingIntegrationsAdvancedConfig from "./floating-integrations-advanced-config";
const FloatingIntegrationsComponent = dynamic(()=>import("./floating-integrations-component"));
export default {
    FloatingIntegrationsComponent,
    FloatingIntegrationsConfig,
    FloatingIntegrationsAdvancedConfig
};
